var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-row"},[_c('h1',{staticClass:"heading"},[_vm._v(" "+_vm._s(_vm.heading)+" ")]),_c('h6',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }